{
  "cycle.entite.annonces_prix": "Tier price notices",
  "cycle.entite.avis_consommation": "Usage alerts",
  "cycle.entite.changements_abonnement": "Subscription changes",
  "cycle.entite.coordonnees_facturation": "Billing details",
  "cycle.entite.credits_organisation": "Organisation credits",
  "cycle.entite.demandes_exception": "Billing exception requests",
  "cycle.entite.demandes_exception_evenements": "Exception request events",
  "cycle.entite.devis_revisions": "Quote revisions",
  "cycle.entite.exceptions_facturation": "Granted billing exceptions",
  "cycle.entite.factures": "Invoices and credit notes",
  "cycle.entite.factures_lignes": "Invoice lines",
  "cycle.entite.imputations_credit": "Credit allocations",
  "cycle.entite.liens_paiement": "Invoice payment links",
  "cycle.entite.litiges_paiement": "Payment disputes",
  "cycle.entite.migrations_abonnes": "Tier subscriber migrations",
  "cycle.entite.moyens_paiement": "Payment methods",
  "cycle.entite.paliers_prix": "Tier version prices",
  "cycle.entite.paliers_versions": "Tier versions",
  "cycle.entite.plan_catalog": "Organisation custom tiers",
  "cycle.entite.reglements_recus": "Payments received",
  "v9.paliers.abonnees.vide": "No organisation subscribes to this plan.",
  "v9.paliers.annuler": "Cancel",
  "v9.paliers.brouillon.enregistre": "Tier draft saved.",
  "v9.paliers.brouillon_v": "draft v{{version}}",
  "v9.paliers.carte_iban_prestataire": "Cards and IBANs are entered with the payment provider: DoIt never receives them.",
  "v9.paliers.champ.code": "Plan code",
  "v9.paliers.champ.code.aide": "Lowercase letters, digits and hyphens, at most 20 characters; the “sm-” prefix is reserved.",
  "v9.paliers.champ.devise": "Currency",
  "v9.paliers.champ.effet_le": "Effective date",
  "v9.paliers.champ.mode": "Mode",
  "v9.paliers.champ.motif": "Reason",
  "v9.paliers.champ.nom": "Plan name",
  "v9.paliers.champ.periodicite": "Billing period",
  "v9.paliers.champ.preavis": "Notice (days)",
  "v9.paliers.champ.prix": "Price",
  "v9.paliers.champ.prix_par_devise": "Prices by currency",
  "v9.paliers.champ.quotas": "Quotas",
  "v9.paliers.champ.version_cible": "Target version",
  "v9.paliers.code.CONTEXTE_INCOMPLET": "No organisation is linked to your session.",
  "v9.paliers.code.DROIT_NON_TENU": "You do not hold the right required for this action.",
  "v9.paliers.code.PALIER_CODE_DEJA_UTILISE": "This code is already used by a plan, withdrawn ones included.",
  "v9.paliers.code.PALIER_DEJA_RETIRE": "This plan has already been withdrawn.",
  "v9.paliers.code.PALIER_NOM_DEJA_UTILISE": "This name is already used by another plan.",
  "v9.paliers.code.PALIER_PREAVIS_INSUFFISANT": "Price increase: the notice is shorter than the billing settings minimum.",
  "v9.paliers.code.PALIER_VERSION_NON_BROUILLON": "This version is published: create a new version to change it.",
  "v9.paliers.code.PALIER_VERSION_NON_PUBLIEE": "The target version is not published.",
  "v9.paliers.code.PRESTATAIRE_INDISPONIBLE": "The payment provider cannot be reached: nothing was changed.",
  "v9.paliers.code.PROPRIETAIRE_SEUL": "Reserved to the organisation owner.",
  "v9.paliers.code.RESOURCE_UNAVAILABLE": "Plan or version not found.",
  "v9.paliers.code.SANS_SESSION": "Your session has expired: sign in again.",
  "v9.paliers.code.VALIDATION_ERROR": "Input rejected: check the code, quotas, currencies and amounts.",
  "v9.paliers.code.VERSION_CONFLICT": "This plan was changed meanwhile: reload the page before trying again.",
  "v9.paliers.colonne.abonnes": "Subscribers",
  "v9.paliers.colonne.actions": "Actions",
  "v9.paliers.colonne.palier": "Plan",
  "v9.paliers.colonne.statut": "Status",
  "v9.paliers.colonne.version": "Current version",
  "v9.paliers.comparer.actuel": "Your current plan",
  "v9.paliers.comparer.changer_periodicite": "Change billing period",
  "v9.paliers.comparer.choisir": "Choose this plan",
  "v9.paliers.comparer.depasse": "What exceeds the target plan",
  "v9.paliers.comparer.devis": "Request a quote",
  "v9.paliers.comparer.effet.actuel": "Current plan.",
  "v9.paliers.comparer.effet.descente": "Downgrade: lower quotas.",
  "v9.paliers.comparer.effet.descente_bloquee": "Downgrade blocked: your usage exceeds this plan’s quotas.",
  "v9.paliers.comparer.effet.montee": "Upgrade: higher quotas.",
  "v9.paliers.comparer.raison.changement_a_venir": "Self-service tier change arrives with the subscription change screen.",
  "v9.paliers.comparer.raison.devis_a_venir": "Quote requests arrive with the exception requests screen.",
  "v9.paliers.comparer.raison.grise_palier_actuel_meme_periodicite": "This is already your plan, at this billing period.",
  "v9.paliers.comparer.raison.grise_usage_au_dessus_des_quotas_cibles": "Your usage exceeds this plan’s quotas: reduce it before downgrading.",
  "v9.paliers.comparer.raison.sur_devis": "Quote-based plan: request a quote.",
  "v9.paliers.comparer.retour": "Back to subscription",
  "v9.paliers.comparer.sans_prix_periodicite": "No price for this billing period.",
  "v9.paliers.comparer.sur_devis": "Quote-based",
  "v9.paliers.comparer.vide": "No published plan yet.",
  "v9.paliers.depart.brouillon": "Editing the draft (version {{version}}).",
  "v9.paliers.depart.publiee": "New version based on published version {{version}}.",
  "v9.paliers.ecran.dialogue-palier": "Create or edit a plan (draft)",
  "v9.paliers.ecran.organisation-paliers-comparer": "Compare plans and choose one",
  "v9.paliers.ecran.plateforme-palier-fiche": "Plan — quotas, prices and subscribers",
  "v9.paliers.ecran.plateforme-paliers": "Plan catalogue",
  "v9.paliers.effet_abonnements.au_prochain_renouvellement": "Subscribers keep their version until their next renewal.",
  "v9.paliers.effet_abonnements.aucun_abonne": "No subscriber: publishing affects no organisation.",
  "v9.paliers.effet_le": "effective {{date}}",
  "v9.paliers.en_cours": "In progress…",
  "v9.paliers.enregistrer_brouillon": "Save draft",
  "v9.paliers.erreur.enregistrer": "The draft was not saved.",
  "v9.paliers.erreur.migrer": "The migration was not scheduled.",
  "v9.paliers.erreur.publier": "The version was not published.",
  "v9.paliers.erreur.retirer": "The plan was not withdrawn.",
  "v9.paliers.etat.chargement": "Loading: {{quoi}}…",
  "v9.paliers.etat.erreur": "Could not read: {{quoi}}.",
  "v9.paliers.etat.refus": "Access denied.",
  "v9.paliers.etat.vide": "Nothing to show.",
  "v9.paliers.invalide.code": "Invalid code: lowercase letters, digits and hyphens, 2 to 20 characters, no “sm-”.",
  "v9.paliers.invalide.doublon": "One price per currency and billing period.",
  "v9.paliers.invalide.motif": "A reason for the withdrawal is required.",
  "v9.paliers.invalide.nom": "The name is required.",
  "v9.paliers.invalide.prix": "Each price is a non-negative amount.",
  "v9.paliers.invalide.quota": "Each quota is a non-negative whole number.",
  "v9.paliers.invalide.version_cible": "Choose a published version as the target.",
  "v9.paliers.liste.vide": "No plan in the catalogue.",
  "v9.paliers.migrer": "Migrate subscribers",
  "v9.paliers.migrer.bloquee": "{{organisation}}: blocked by its usage ({{quotas}})",
  "v9.paliers.migrer.bloquees": "Organisations blocked by their usage",
  "v9.paliers.migrer.programmees": "{{n}} organisation(s) scheduled.",
  "v9.paliers.migrer.selection": "Organisations (none ticked: all)",
  "v9.paliers.migrer.titre": "Migrate subscribers to a version",
  "v9.paliers.mode.creation": "New plan",
  "v9.paliers.mode.nouvelle_version": "New version of plan {{nom}}",
  "v9.paliers.mode_migration.au_renouvellement": "At renewal",
  "v9.paliers.mode_migration.immediat_au_prorata": "Immediate, prorated",
  "v9.paliers.modifier_brouillon": "Edit draft",
  "v9.paliers.nouveau": "New plan",
  "v9.paliers.nouvelle_version": "New version",
  "v9.paliers.periodicite.annuelle": "yearly",
  "v9.paliers.periodicite.mensuelle": "monthly",
  "v9.paliers.preavis.aide": "A price increase requires the billing settings minimum notice.",
  "v9.paliers.prix.ajouter": "Add price",
  "v9.paliers.prix.aucun": "No price.",
  "v9.paliers.prix.retirer": "Remove price {{devise}} {{periodicite}}",
  "v9.paliers.publier": "Publish version {{version}}",
  "v9.paliers.publier.succes": "Version published; {{annonces}} price notice(s) sent.",
  "v9.paliers.publier.titre": "Publish version {{version}}",
  "v9.paliers.quoi.catalogue": "the plan catalogue",
  "v9.paliers.quoi.palier": "the plan",
  "v9.paliers.quoi.paliers_publies": "the published plans",
  "v9.paliers.quota.ai_calls_per_day": "AI calls per day",
  "v9.paliers.quota.document_size_mb": "Document size (MB)",
  "v9.paliers.quota.documents_count": "Documents",
  "v9.paliers.quota.requests_per_minute": "Requests per minute",
  "v9.paliers.quota.tokens_per_day": "Tokens per day",
  "v9.paliers.reessayer": "Retry",
  "v9.paliers.retirer": "Withdraw from offer",
  "v9.paliers.retirer.aide": "Subscribers keep the plan until their renewal.",
  "v9.paliers.retirer.deja": "Withdrawn on {{date}}.",
  "v9.paliers.retirer.titre": "Withdraw the plan from the offer",
  "v9.paliers.retour": "Back to catalogue",
  "v9.paliers.section.abonnees": "Subscribed organisations",
  "v9.paliers.section.prix": "Prices",
  "v9.paliers.section.quotas": "Quotas",
  "v9.paliers.section.versions": "Versions",
  "v9.paliers.statut.brouillon": "Draft",
  "v9.paliers.statut.publie": "Published",
  "v9.paliers.statut.retire": "Withdrawn",
  "v9.paliers.statut_version.brouillon": "draft",
  "v9.paliers.statut_version.publiee": "published",
  "v9.paliers.statut_version.remplacee": "superseded",
  "v9.paliers.synchronisation.a_synchroniser": "to synchronise",
  "v9.paliers.synchronisation.echec": "synchronisation failed",
  "v9.paliers.synchronisation.synchronise": "synchronised with the provider",
  "v9.paliers.version_historique": "legacy limits",
  "v9.paliers.version_n": "version {{version}}",
  "v9.paliers.versions.vide": "No version.",
  "v9.paliers.voir": "View",
  "v9.paliers.voir_palier": "View plan {{nom}}",
  "v9.paliers.comparer.aucun_depassement": "No quota above this tier.",
  "v9.paliers.depart.creation": "New tier: it starts at version 1, as a draft."
}
